import '../../styles/index.scss';

import { graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';

import { renderContentCards } from '../../components/Blocks';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Metadata from '../../components/Metadata';
import { BREAKPOINTS } from '../../constants/breakpoints';

const FranchisePage = ({ data: { contentfulFranchises }, location }) => {
  const [viewport, setViewport] = useState(undefined);

  const handleResize = () => {
    if (window.innerWidth <= BREAKPOINTS.mobileXL) {
      setViewport('mobile');
    } else if (window.innerWidth <= BREAKPOINTS.tabletXL) {
      setViewport('tablet');
    } else {
      setViewport('desktop');
    }
  };

  // TODO: combine all resize events into one resize event at app level
  // and pass data down data through context API.
  // Add throttling, debouncing to handle performance issues if needed
  useEffect(() => {
    window.addEventListener('resize', () => handleResize(window));
    handleResize();
    return () =>
      window.removeEventListener('resize', () => handleResize(window));
  }, []);

  const cardsSortedByDate = [
    ...(contentfulFranchises.article___list || []),
    ...(contentfulFranchises.article___long_form || []),
    ...(contentfulFranchises.article___podcast || []),
    ...(contentfulFranchises.story || []),
  ].sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate));

  const fallbackMetadata = {
    title: contentfulFranchises.franchiseName,
  };

  return (
    <>
      <Metadata
        data={contentfulFranchises.metadata || fallbackMetadata}
        location={location}
      />
      <Header showBorder />
      <div className="franchise__header">
        {contentfulFranchises.franchiseImage && (
          <div className="franchise__header--image">
            <GatsbyImage
              alt={contentfulFranchises.franchiseName}
              image={getImage(contentfulFranchises.franchiseImage)}
            />
          </div>
        )}
        <div className="franchise__header--text">
          <h1>{contentfulFranchises.franchiseName}</h1>
          <p>{contentfulFranchises.franchiseDescription}</p>
        </div>
      </div>
      <div className="franchise-page" data-module-id="franchise_page">
        {cardsSortedByDate && renderContentCards(cardsSortedByDate, viewport)}
      </div>
      <Footer />
    </>
  );
};

export const query = graphql`
  query ($slug: String) {
    contentfulFranchises(slug: { eq: $slug }) {
      franchiseName
      franchiseImage {
        ...ContentfulBaseImageFragment
      }
      franchiseDescription
      article___list {
        ...ContentfulArticleList
      }
      article___long_form {
        ...ContentfulArticleLongForm
      }
      article___podcast {
        ...ContentfulArticlePodcast
      }
      story {
        ...ContentfulStory
      }
      metadata {
        ...ContentfulMetadataFragment
      }
    }
  }
`;

FranchisePage.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export default FranchisePage;
